module.exports = __webpack_public_path__ + "img/index-sol3.cabf4ecb.png";